import {InfiniteData} from '@tanstack/react-query';
import {twMerge} from '../common/twMerge';
import {Loading} from '../design-system/atoms/Loading/Loading';
import {ReactQueryInfiniteFetcherChildrenProps} from './CodegenReactQueryType.type';
import {ReactQueryInfiniteLoader} from './ReactQueryInfiniteLoader';

export function ReactQueryInfiniteFetcherChildren<TQuery>({
  children,
  isLoading,
  showInfiniteLoader = true,
  data,
  enabled,
  type,
  onStartFetchNextPage,
  onStartFetchPrevPage,
  loadingWrapperClassName,
  ...rest
}: {
  isLoading: boolean;
  showInfiniteLoader?: boolean;
  data?: InfiniteData<TQuery>;
} & ReactQueryInfiniteFetcherChildrenProps<TQuery> & {
    isFetching?: boolean;
    hasPreviousPage?: boolean;
    hasNextPage?: boolean;
    fetchNextPage: () => void;
    fetchPreviousPage: () => void;
    isFetchingNextPage?: boolean;
  }) {
  // enabled : false 라면 Fetch 할 필요가 없는 경우라는 의미로 자식을 그대로 보여줍니다.
  if (enabled === false) {
    return <>{children}</>;
  }
  if (isLoading) {
    return (
      <div className={twMerge(loadingWrapperClassName, 'flex-center-full')}>
        <Loading />
      </div>
    );
  }
  if (data) {
    const _children =
      typeof children === 'function' ? children(data) : children;

    if (!showInfiniteLoader) {
      return <>{_children}</>;
    }
    return (
      <ReactQueryInfiniteLoader
        type={type}
        {...rest}
        onStartFetchNextPage={onStartFetchNextPage}
        onStartFetchPrevPage={onStartFetchPrevPage}
      >
        {_children}
      </ReactQueryInfiniteLoader>
    );
  }
  return null;
}
